import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { trans } from '../../../localization/language';
import { ACCOUNT_TYPE, ACCOUNT_TYPE_TEMPLATE, VERIFICATION_TOOL } from '../../../constants';
import * as verificationActions from '../../../actions/verification';
import { getSendOTPErrorMessage, getVerifyOTPErrorMessage } from '../../../utils.js'

class EmailVerification extends React.Component {
    constructor(props) {
		super(props);
		this.state = {
			code: '',
			ac_type: props.ac_type
		}
	}

	handleGetCode() {
		var template = ACCOUNT_TYPE_TEMPLATE[this.state.ac_type];
		this.props.getCode(null, true, this.props.language.lang, template['template_id'], template['template_params']);
	}

	handleSubmit(event) {
		event.preventDefault();
		this.props.submitCode(this.state.code, this.state.ac_type, VERIFICATION_TOOL.EMAIL);
	}

	handleChangeCode(event) {
		this.setState({code: event.target.value});
	}

	checkError() {
		var errMsg = null;
		if (this.props.verification.get_status) {
			errMsg = getSendOTPErrorMessage(this.props.verification.get_status);
		} else if (this.props.verification.verify_status) {
			errMsg = getVerifyOTPErrorMessage(this.props.verification.verify_status);
		}
		if (errMsg) {
			return (
				<div className="content__form-errmsg-item content__form-errmsg-item--visible">
					{errMsg}
				</div>
			);
		}
	}

	render() {
		return (
			<div className="content-item__main">
				<div className="content-item--ipage__main">
					<div className="content__sendinfo" id="J-sendinfo">
						{this.props.ac_type == ACCOUNT_TYPE.OTPTOKEN && <div className="content__sendinfo-before">
							{trans('revoke_token_hint')}
						</div>}
						<div className="content__sendinfo-before">{trans('get_email_code_hint')}</div>
						<div className="content__sendinfo-after">
							{trans('sent_email_code_info')}
						</div>
					</div>
					<div className="content__form">
						<form method="post" action="" id="J-validated-form" onSubmit={this.handleSubmit.bind(this)}>
							<div className="content__phone">
								<div className="content__email-icon"></div>
								<div className="content__email-addr">{this.props.email}</div>
							</div>
							<div className="content__form-otpcode">
								<div className="content__form-input">
									<input type="tel" maxLength="8" className="content__form-input-widget J-validated-field"
										placeholder={trans('verify_code_placeholder')}
										onChange={this.handleChangeCode.bind(this)}>
									</input>
								</div>
								<a href="javascript:;" className="content__form-getotp" id="J-getotp-trigger">
									<div className="content__form-getotp-before" onClick={this.handleGetCode.bind(this)}>
										{trans('get_code_btn')}
									</div>
									<div className="content__form-getotp-after">
										{trans('wait')} <span id="J-getotp-cd"></span>s
									</div>
								</a>
							</div>
							<div className="content__form-errmsg" id="J-errdisplay-otp">
								{this.checkError()}
							</div>
							<div className="content__submit-wrap">
								<input type="submit" className="content__submit" value={trans('verify_btn')}></input>
							</div>
						</form>
					</div>
				</div>
			</div>
		);
	}
}

function mapStateToProps(state) {
	return {
		verification: state.verification,
		language: state.data.language,
	}
}

function mapDispatchToProps(dispatch) {
	return bindActionCreators(Object.assign({}, verificationActions), dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(EmailVerification);


// WEBPACK FOOTER //
// ./app/components/security/verification/EmailVerification.js